// Educabolivia/src/mock/users.js
const users = [
  {
    id: 1,
    first_name: "Carlos",
    last_name: "Santana",
    email: "instructor@example.com",
    role: "instructor",
    courses: [1, 3],
    enrolled: [],
    social: {
      facebook: "",
      instagram: "",
      linkedin: "",
      tiktok: ""
    },
    settings: {
      showProfile: true,
      showCourses: true
    },
    bio: "Instructor profesional con 10 años de experiencia",
    title: "Instructor Principal",
    language: "Español"
  },
  {
    id: 2,
    first_name: "Eduardo",
    last_name: "Flores",
    email: "student@example.com",
    role: "student",
    courses: [],
    enrolled: [1, 2],
    social: {
      facebook: "",
      instagram: "",
      linkedin: "",
      tiktok: ""
    },
    settings: {
      showProfile: true,
      showCourses: true
    },
    bio: "Estudiante de desarrollo web",
    title: "Estudiante de Ingeniería",
    language: "Español"
  },
  {
    id: 3,
    first_name: "Maria",
    last_name: "Gomez",
    email: "instructor2@example.com",
    role: "instructor",
    courses: [2],
    enrolled: [],
    social: {
      facebook: "",
      instagram: "",
      linkedin: "",
      tiktok: ""
    },
    settings: {
      showProfile: true,
      showCourses: true
    },
    bio: "Especialista en diseño UI/UX",
    title: "Diseñadora Senior",
    language: "Español"
  }
];

export default users;
